module.exports = __webpack_public_path__ + "media/offers_icons/ilosc-miejsc-7d2760c3.svg";